import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

// A theme with custom primary and secondary color.
// import theme from 'theme/app.theme.js';
import theme from './theme/app.theme';
import { getQueryValue } from 'utils/index';

function saveSession(location) {
  let sessionKeys = ["state","session_state","code"];
  sessionKeys.forEach((key) => {
    let val = getQueryValue(key);
    if(val.length > 0)
      window.localStorage.setItem(key,val)
  })
}

function withRoot(Component) {
  function WithRoot(props) {
    saveSession(props.location);
    // MuiThemeProvider makes the theme available down the React tree
    // thanks to React context.
    return (
      <MuiThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <Component {...props} />
      </MuiThemeProvider>
    );
  }

  return WithRoot;
}

export default withRoot;